// MediaPreviewBar.js — Simplified
import React from "react";

export default function MediaPreviewBar({ pendingMedia, onDismiss }) {
  const items = Array.isArray(pendingMedia)
    ? pendingMedia
    : pendingMedia
    ? [pendingMedia]
    : [];

  if (!items.length) return null;

  return (
    <div className="flex items-center gap-3 px-3 py-2 border-t border-neutral-300/40 dark:border-neutral-600/40 bg-neutral-100/80 dark:bg-neutral-700/60 backdrop-blur">

      {/* Thumbnail strip */}
      <div className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto">
        {items.map((media, index) =>
          ["image", "gif"].includes(media.type) ? (
            <img
              key={media.previewUrl || index}
              src={media.previewUrl}
              alt="preview"
              className="w-10 h-10 sm:w-12 sm:h-12 object-cover rounded shrink-0"
            />
          ) : (
            <div key={media.previewUrl || index} className="text-2xl shrink-0">
              {media.type === "video" ? "🎬" : media.type === "audio" ? "🎵" : "📄"}
            </div>
          )
        )}
      </div>

      {/* File Info */}
      <div className="text-sm min-w-0 shrink-0">
        {items.length === 1 ? (
          <>
            <div className="font-medium truncate max-w-[140px] sm:max-w-[200px]">
              {items[0].fileName}
            </div>
            {items[0].fileSize && (
              <div className="text-xs text-neutral-500">
                {(items[0].fileSize / 1024 / 1024).toFixed(2)} MB
              </div>
            )}
          </>
        ) : (
          <div className="font-medium whitespace-nowrap">{items.length} files</div>
        )}
      </div>

      {/* Dismiss */}
      <button
        className="text-lg text-neutral-500 hover:text-red-500 p-1 shrink-0 touch-manipulation"
        onClick={onDismiss}
      >
        ✕
      </button>
    </div>
  );
}